import { IMessageDispatcher } from './IMessageDispatcher';

export const TOKEN_RETRIES: number = 3;

export class TokenManager {
	private isFetching: boolean = false;
	private tokenFetchPromise: Promise<string> | null = null;

	constructor(
		private messageDispatcher: IMessageDispatcher
	) {}

	public getCurrentToken(): Promise<string> {
		//console.info('getCurrentToken')
		if (this.tokenFetchPromise) {
			return this.tokenFetchPromise;
		}

		this.isFetching = true;

		this.tokenFetchPromise = this.messageDispatcher.getToken()
			.catch(() => Promise.reject({ tokenFetchError: true }));

		this.tokenFetchPromise
			.then(() => this.isFetching = false, () => this.isFetching = false);

		return this.tokenFetchPromise;
	}

	public invalidateToken(): void {
		if (this.isFetching) {
			return;
		}

		this.tokenFetchPromise = null;
	}
}
